// extracted by mini-css-extract-plugin
module.exports = {"myVideo":"LocalPreview_myVideo__2q9mh","myVideoHidden":"LocalPreview_myVideoHidden__Y6I8g"};